import { ReactNode } from "react";
import styled from "styled-components";
import { minMedium } from "@songtradr-one/components-frontend";

// TEXT

// STYLES
export const Content = styled.div<{ $hidden?: boolean }>`
  display: ${({ $hidden }) => ($hidden ? "none" : "flex")};
  height: 100%;

  @media ${minMedium} {
    padding: 1.5rem 3rem;
  }
`;

// DATA

// TYPES
export type Props = {
  isActive: boolean;
  children: ReactNode;
};

// CONSTANTS

// FUNCTIONS

// ASSETS
